<template>
    <section id="home-bg-video"
             class="bg-cover bg-overlay-black-6 height-100 no-padding width-100"
             :style="'height:' + windowHeight + 'px!important;background:url(' + bg + ');background-size:cover;'"
             >
        <div style="margin-left:-80px;" v-if="videoId" class="bgvideo">
            <youtube :video-id="videoId"
                     :player-vars="{autoplay: 1, controls: 0, showinfo: 0, disablekb: 1, loop: 1, playlist: videoId, fadeOnStartTime:500}"
                     :player-width="windowWidth + 160"
                     :player-height="windowHeight + 90"
                     :mute="true"
            ></youtube>
        </div>
        <div class="display-table height-100 position-absolute position-top position-left width-100">
            <div class="display-table-cell vertical-align-middle">
                <div class="container">
                    <div class="row">
                        <div class="col-md-10 col-md-offset-1 text-center">
                            <h2 class="vw-bold display-block font-family-alt font-weight-700 letter-spacing-2 text-uppercase text-white xs-title-extra-large sm-title-extra-large-3 title-extra-large-5">
                                <slot name="title"></slot>
                            </h2>
                            <div class="col-md-10 col-md-offset-1">
                                <p class="vw-bold font-family-alt letter-spacing-1 margin-3 no-margin-bottom no-margin-rl text-gray-light xs-text-large text-extra-large text-uppercase">
                                    <slot name="subtitle"></slot>
                                </p>
                            </div>
                            <a class="page-scroll btn btn-base-color sm-btn-medium btn-large margin-4-5 no-margin-bottom no-margin-rl"
                               @click="goToMenuItem('register')"
                            >
                                {{ buttonText }}
                                </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import $ from 'jquery'
export default {
    props: {
        videoId: {
            type: String,
            required: true
        },
        buttonText: {
            type: String,
            required: true
        },
        bg: {
            type: String,
            required: true
        }
    },
    computed: {
        windowWidth () {
            return window.innerWidth
        },
        windowHeight () {
            return window.innerHeight
        }
    },
    methods: {
        goToMenuItem (id) {
            this.showMenu = false
            $('html, body').animate({
                scrollTop: $('#' + id).offset().top
            }, 500)
        }
    }
}
</script>
<style scoped>
    @media screen and (max-width:768px) {
        .bgvideo{
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// intro.vue?0494016f